import { render, staticRenderFns } from "./TransferProductCard.vue?vue&type=template&id=007bbcea&"
import script from "./TransferProductCard.vue?vue&type=script&lang=js&"
export * from "./TransferProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports